import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function OrderCountdown({ expiresAt, status, orderId, onExpire }) {
  const [timeLeft, setTimeLeft] = useState('');
  const [isExpired, setIsExpired] = useState(false);
  const [hasNotifiedExpiry, setHasNotifiedExpiry] = useState(false);

  useEffect(() => {
    if (status !== 'pending') {
      setTimeLeft('--');
      return;
    }

    const calculateTimeLeft = () => {
      const now = new Date();
      
      // Asegurar que expiresAt se interprete como UTC
      let expiryDate;
      if (typeof expiresAt === 'string') {
        // Si no termina en 'Z', agregarla para indicar UTC
        const isoString = expiresAt.endsWith('Z') ? expiresAt : expiresAt + 'Z';
        expiryDate = new Date(isoString);
      } else {
        expiryDate = new Date(expiresAt);
      }
      
      // Calcular diferencia en milisegundos
      const diff = expiryDate.getTime() - now.getTime();

      if (diff <= 0) {
        setIsExpired(true);
        setTimeLeft('Expirada');
        
        // Notificar expiración una sola vez
        if (!hasNotifiedExpiry && onExpire) {
          setHasNotifiedExpiry(true);
          onExpire(orderId);
        }
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
      } else if (minutes > 0) {
        setTimeLeft(`${minutes}m ${seconds}s`);
      } else {
        setTimeLeft(`${seconds}s`);
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [expiresAt, status, orderId, onExpire, hasNotifiedExpiry]);

  if (status !== 'pending') {
    return <span className="text-xs text-gray-400">--</span>;
  }

  return (
    <div className={`flex items-center gap-1 text-xs font-medium ${
      isExpired ? 'text-red-600' : 
      timeLeft.includes('s') && !timeLeft.includes('m') ? 'text-red-600' :
      timeLeft.includes('m') && parseInt(timeLeft) < 5 ? 'text-orange-600' :
      'text-green-600'
    }`}>
      <Clock className="w-3 h-3" />
      {timeLeft}
    </div>
  );
}

